{
    "homePage": "Home Page",
    "reservationBannerTitle": "Reservations available for 2025-2026 Moderna COVID-19 Vaccine Formula*",
    "reservationBannerDescription": "*Subject to FDA approval or emergency use authorization of 2025-2026 formula ",
    "reservationBannerButton": "Reserve now",
    "rsvBannerHeader": "RSV Vaccine Now Shipping.",
    "rsvBannerText": "Available to order June 17, 2024.",
    "orderBannerText": "Order Moderna products",
    "spikevaxBannerHeader": "Moderna COVID-19 Vaccine 2024-2025 Formula Now Available.",
    "spikevaxBannerText": ""
}
